import { useEffect, useState } from 'react';
import { HIDE_CONTENTS_TIMEOUT } from '../constants/SidebarConstants';
import CollapseButton from './CollapseButton';
import CollapsableSidebarFadingContent from './CollapsableSidebarFadingContent';
import { View } from 'foundations-components/components/View';

/**
 * @description This wrapper handles the sidebar styling and CollapsableSidebar logic
 * allowing children to focus on rendering only the sidebar contents
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CollapsableSidebarContentWrapper = ({
  children,
  collapsed,
  isLocked,
  toggleSidebar,
  collapseButtonPosition,
  showTooltip,
  collapseButtonRef
}) => {
  const [shouldHideContent, setHideContent] = useState(false);
  useEffect(() => {
    let timeout;
    if (collapsed) {
      setHideContent(true);
    } else {
      timeout = setTimeout(() => setHideContent(false), HIDE_CONTENTS_TIMEOUT);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [collapsed]);
  return /*#__PURE__*/_jsxs(View, {
    backgroundColor: "fill-surface-default",
    blockSize: "100%",
    borderInlineEndColor: "border-core-subtle",
    borderInlineEndStyle: "solid",
    borderInlineEndWidth: "100",
    inlineSize: "100%",
    children: [!collapsed && /*#__PURE__*/_jsx(CollapsableSidebarFadingContent, {
      hide: shouldHideContent,
      children: children
    }), /*#__PURE__*/_jsx(CollapseButton, {
      isLocked: isLocked,
      collapsed: collapsed,
      onClick: toggleSidebar,
      position: collapseButtonPosition,
      showTooltip: showTooltip,
      collapseButtonRef: collapseButtonRef
    })]
  });
};
CollapsableSidebarContentWrapper.displayName = 'CollapsableSidebarContentWrapper';
export default CollapsableSidebarContentWrapper;